<template>
    <div class="timeline_item_dot animated zoomIn">
        <kgr-child-status-icon
            :title="title"
            :style="{ borderColor }"
            :status="status"
            class="square"
        />
    </div>
</template>

<script>
import ChildStatusIcon from '../../child/contract/ChildStatusIcon';

export default {
    components: {
        'kgr-child-status-icon': ChildStatusIcon,
    },
    props: {
        title: {
            type: String,
            required: false,
        },
        status: {
            type: String,
            required: true,
        },
    },
    computed: {
        borderColor() {
            switch (this.status) {
                case 'signed_up':
                    return '#cbcbcb';

                case 'on_waiting_list':
                case 'waiting_for_contract_signing':
                case 'waiting_for_contract_start':
                    return '#FFB300';

                case 'active':
                    return '#43A047';

                case 'archived':
                    return '#E53935';
            }

            throw new Error('unknown status "' + this.status + '"');
        },
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.timeline_item_dot {
    border-radius: 50%;
    width: 28px;
    height: 28px;
    margin: 5px;
    z-index: 1;
    background-color: #ffffff;
    .square {
        border-radius: 4px;
        box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);
        border: 1px solid;
        &:active {
            box-shadow: none;
            margin: 9px 7px 7px 9px;
        }
    }
}
</style>
